var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.companies.length
    ? _c("AllDocumentsSearchableList", {
        attrs: { currentUser: _vm.currentUser, query: _vm.query },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function ({ document, onDocumentDeleted }) {
                return [
                  _vm.isProjectExist(document)
                    ? _c(
                        "DocumentItem",
                        {
                          attrs: {
                            document: document,
                            currentUser: _vm.currentUser,
                            frozen: _vm.isDocumentFrozen(document),
                          },
                          on: { documentDeleted: onDocumentDeleted },
                        },
                        [
                          _c("CardBodyLink", {
                            attrs: {
                              label: "Client",
                              routeParams: { id: _vm.getProject(document).id },
                              routeName:
                                _vm.RouteNames.CONTRACTOR_PROJECT_ACTIVITY,
                              value:
                                _vm.getProject(document)?.name || "No project",
                            },
                          }),
                          _c("CardBodyLink", {
                            attrs: {
                              label: "Company",
                              routeParams: { id: document.company.id },
                              routeName: _vm.RouteNames.NETWORK_COMPANY,
                              value: document.company.business_name,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.isAttachedToApplication(document)
                    ? _c(
                        "DocumentItem",
                        {
                          attrs: {
                            document: document,
                            currentUser: _vm.currentUser,
                            frozen: _vm.isDocumentFrozen(document),
                          },
                          on: { documentDeleted: onDocumentDeleted },
                        },
                        [
                          _c("CardBodyLink", {
                            attrs: {
                              label: "Attached to",
                              routeQuery: _vm.getRouteQuery(document),
                              routeName: _vm.RouteNames.JOBBOARD_APPLICATIONS,
                              value: _vm.getAttachedToApplications(document),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
          ],
          null,
          false,
          2778658610
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }